import { render, staticRenderFns } from "./infomation-share-list.vue?vue&type=template&id=b8af5ee4&scoped=true"
import script from "./infomation-share-list.vue?vue&type=script&lang=js"
export * from "./infomation-share-list.vue?vue&type=script&lang=js"
import style0 from "./infomation-share-list.vue?vue&type=style&index=0&id=b8af5ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af5ee4",
  null
  
)

export default component.exports